export default "__VITE_ASSET__D8LJIUZ1__"